import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from "@environment";

@Injectable({
    providedIn: 'root'
})
export class MaintenanceModeGuard implements CanActivate {

    constructor(
        private router: Router,
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (environment.maintenance) {
            this.router.navigateByUrl('/maintenance').then();
            return false;
        }

        return true;
    }
}
